/**
 * FaqSearch - FAQ search/filter input.
 * Custom element: <faq-search>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class FaqSearch extends ThemeComponent {}
setFunctionName(FaqSearch, "FaqSearch");
const propertyTypes = {};
FaqSearch.prototype.$name = "FaqSearch";
FaqSearch.prototype.$info = JSON.parse('{"name":"FaqSearch","meta":{"isLegacy":false,"selector":"faq-search"},"props":[],"refs":[]}');
FaqSearch.prototype.$info.component = FaqSearch;
for (const prop of FaqSearch.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Faq/FaqSearch.ts", {
  FaqSearch: FaqSearch
}, void 0);